import { Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ultimate-thread-group',
  templateUrl: './ultimate-thread-group.component.html',
  styleUrls: ['./ultimate-thread-group.component.less']
})
export class UltimateThreadGroupComponent implements OnInit {
  displayedColumns = ['startThreadsCount', 'initialDelay', 'startupTime', 'holdLoadFor', 'shutDownTime', 'Action'];
  threadGroupForm: any;
  @Input() addedList = [];
  isEditing = false;
  editingindex = false;
  defaultData = [
    {
      startThreadsCount: 1,
      initialDelay: 0,
      startupTime: 0,
      holdLoadFor: 1,
      shutDownTime: 0,
    }
  ];
  @Input() data = [];
  @Input() edited: any;
  @Output() cancelCreation: EventEmitter<any> = new EventEmitter();
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();

  constructor(private formBuilder: FormBuilder) {
    this.setForm();
  }

  ngOnInit() {
    if(this.addedList === undefined || this.addedList === null) {
      this.addedList = [];
    }
  }

  setForm() {
    this.threadGroupForm = this.formBuilder.group({
      startThreadsCount: [1, Validators.required],
      initialDelay: [0, Validators.required],
      startupTime: [0, Validators.required],
      holdLoadFor: [1, Validators.required],
      shutDownTime: [0, Validators.required]
    });
  }

  addToList() {
    if(!this.threadGroupForm.invalid) {
      let tempObject = JSON.parse(JSON.stringify(this.addedList));
      tempObject.push(this.threadGroupForm.value);
      this.addedList = tempObject;
      this.threadGroupForm.reset();
      this.threadGroupForm.patchValue(this.defaultData[0]);
    }
  }

  deleteRow(index) {
    let tempObject = JSON.parse(JSON.stringify(this.addedList));
    tempObject.splice(index, 1);
    this.addedList = tempObject;
    this.threadGroupForm.patchValue(this.defaultData[0]);
  }

  editList(index) {
    this.isEditing = true;
    this.editingindex = index;
    this.threadGroupForm.patchValue(this.addedList[index]);
  }

  updateList() {
    if(!this.threadGroupForm.invalid) {
      let tempObject = JSON.parse(JSON.stringify(this.addedList));
      tempObject.splice(this.editingindex, 1, this.threadGroupForm.value);
      this.addedList = tempObject;
      this.isEditing = false;
      this.editingindex = null;
      this.threadGroupForm.reset();
      this.threadGroupForm.patchValue(this.defaultData[0]);
    }
  }

  cloneList(index) {
    let tempObject = JSON.parse(JSON.stringify(this.addedList));
    tempObject.splice(index + 1, 0, tempObject[index]);
    this.addedList = tempObject;
  }

  cancelEditList() {
    this.isEditing = false;
    this.editingindex = null;
    this.threadGroupForm.reset();
  }

  saveConfiguration() {

    this.notifyParent.emit({ data : this.addedList, edited :  this.edited });
  }

  updateConfiguration() {
    this.notifyParent.emit({ data : this.addedList, edited :  this.edited });
  }

  cancelThreadGroupCreation() {
    this.threadGroupForm.reset();
    this.addedList = [];
    this.cancelCreation.emit();
  }
}
